const productTypeParent = document.getElementById("productTypeParent");
const productTypeChild = document.getElementById("productTypeChild");
const availability1 = document.getElementById("availability1");
const availability0 = document.getElementById("availability0");
const availability = document.getElementById("availability");

// 全体の流れ
window.addEventListener("DOMContentLoaded", () => {
  // フォームに初期値を設定
  setValuesInForm();

  // 選択された親カテゴリによって子カテゴリの表示を変える
  changeChildSelectOption();

  // フォームのURLをセット
  setFormUrl();

  // 親カテゴリの変更があったら子カテゴリの表示を変える
  productTypeParent.addEventListener("change", changeChildSelectOption);

  // 親カテゴリ・子カテゴリのフォームの変更があったらproduct_typeをリセットする
  productTypeParent.addEventListener("change", resetProductType);
  productTypeChild.addEventListener("change", resetProductType);

  // セレクトの変更があったらフォームのURLをセットする関数を実行する
  const productSearchFormSelects = document.querySelectorAll(
    "#productSearchForm select"
  );
  productSearchFormSelects.forEach((productSearchFormSelect) => {
    productSearchFormSelect.addEventListener("change", setFormUrl);
  });

  // チェックボックスの変更があったら隠しフィールドへ設定する
  changeCheckbox();

  // 並び替えの選択が変わったらURLを書き換えてリロードする
  const sortBy = document.querySelectorAll(".facet-filters__sort");
  sortBy.forEach((sort) => {
    sort.addEventListener("change", () => {
      const selectedSort = sort.value;
      const params = new URLSearchParams(window.location.search);
      params.set("sort_by", selectedSort);
      window.location.search = params.toString();
    });
  });
});

// 変数をセットする関数
const getVariables = () => {
  const collectionHandle = getCollectionHandle();
  const sortBy = getParameters("sort_by");
  const age = getParameters("filter.p.m.tmky.age");
  const priceMin = getParameters("filter.v.price.gte");
  const priceMax = getParameters("filter.v.price.lte");
  let vendor = getParameters("filter.p.vendor");
  let types = getTypesParameters();
  const collection = getCollection();
  const collectionRule = getCollectionRule(collection);
  const availability = getParameters("filter.v.availability");

  // collectionRuleがベンダー・タイプの時は変数上書き
  if (collectionRule == "vendor") {
    vendor = getVendorCondition();
  }
  if (collectionRule == "type") {
    types = getTypesCondition();
  }

  return {
    collectionHandle: collectionHandle,
    sortBy: sortBy,
    age: age,
    priceMin: priceMin,
    priceMax: priceMax,
    vendor: vendor,
    types: types,
    collection: collection,
    collectionRule: collectionRule,
    availability: availability,
  };
};

// 親子カテゴリを取得する関数
const getCollectionParentHandleAndChildProductType = () => {
  let collectionParentHandleAndChildProductTypeSet = [];
  const productTypeParentOptions = document.querySelectorAll(
    "#productTypeParent option"
  );
  const productTypeChildOptions = document.querySelectorAll(
    "#productTypeChild option"
  );

  productTypeParentOptions.forEach((productTypeParentOption) => {
    let collectionParentHandleAndChildProductType = {
      parentHandle: productTypeParentOption.value,
      childProductType: [],
    };
    productTypeChildOptions.forEach((productTypeChildOption) => {
      if (
        productTypeChildOption.dataset.parent == productTypeParentOption.value
      ) {
        collectionParentHandleAndChildProductType.childProductType.push(
          productTypeChildOption.dataset.child
        );
      }
    });
    collectionParentHandleAndChildProductTypeSet.push(
      collectionParentHandleAndChildProductType
    );
  });
  return collectionParentHandleAndChildProductTypeSet;
};

// 子カテゴリフォームの表示を切り替える関数
const changeChildSelectOption = () => {
  const productTypeParent = document.getElementById("productTypeParent");
  const productTypeChildWrap = document.getElementById("productTypeChildWrap");
  // 親カテゴリが空のとき
  if (productTypeParent.value == "") {
    productTypeChildWrap.style.display = "none";
    productTypeChild.value = "";
  } else {
    productTypeChildWrap.style.display = "flex";

    const productTypeChildOptions = document.querySelectorAll(
      "#productTypeChild option"
    );
    productTypeChildOptions.forEach((productTypeChildOption) => {
      let productTypeChildOptionParent = productTypeChildOption.dataset.parent;
      // 選択された親カテゴリの値を持つ子カテゴリのみ表示
      if (productTypeParent.value.match(productTypeChildOptionParent)) {
        productTypeChildOption.style.display = "block";
      } else {
        productTypeChildOption.style.display = "none";
      }
      // 選択されている子カテゴリの親カテゴリが異なるとき子カテゴリリセット
      if (productTypeChild.value == productTypeChildOption.value) {
        if (productTypeParent.value != productTypeChildOptionParent) {
          productTypeChild.value = "";
        }
      }
    });
  }
};

// product_typeの隠しフィールドをリセット
const resetProductType = () => {
  const productTypeHiddenForms = document.querySelectorAll(
    ".product_type_hidden"
  );
  productTypeHiddenForms.forEach((productTypeHiddenForm) => {
    productTypeHiddenForm.remove();
  });
};

// フォームに初期値を設定する関数
const setValuesInForm = () => {
  // 変数を初期設定
  const variables = getVariables();

  // 初期値typesの長さを判定して親カテゴリ・子カテゴリをセット
  // 1つだったら子カテゴリが選択されていると判定して子カテゴリをセット
  // 2つ以上だったら親カテゴリのみが選択されていると判定して親カテゴリをセット
  if (variables.types.length == 1) {
    // 子カテゴリと親カテゴリの初期値をフォームにセット
    setParentAndChildCategoryInForm();
  } else if (variables.types.length > 1) {
    // 親カテゴリの初期値をフォームにセット
    setParentCategoryInForm();
  }

  // 年齢の初期値をフォームにセット
  setAgeInForm();
  // ベンダーの初期値をフォームにセット
  setVendorInForm();
  // 価格の初期値をフォームにセット
  setPriceInForm();
  // 在庫有無の初期値をフォームにセット
  setAvailabilityInForm();
};

// コレクションを返す関数
const getCollection = () => {
  const collection = document.getElementById("ProductGridContainer").dataset
    .collection;
  return JSON.parse(collection);
};

// 表示しているコレクションのconditionを返す関数
const getCollectionRule = (collection) => {
  if (collection !== null) {
    const rules = collection.rules;
    let conditions = ["vendor", "tag", "type"];
    for (let h = 0; h < conditions.length; h++) {
      for (let i = 0; i < rules.length; i++) {
        if (rules[i].column == conditions[h]) {
          return conditions[h];
        }
      }
    }
  }
  return "all";
};

// URLからコレクションのハンドルを返す関数
const getCollectionHandle = () => {
  const url = new URL(location.href);
  let pathname = url.pathname;
  while (pathname.match(/\/\//g)) {
    pathname = pathname.replace(/\/\//g, "/");
  }
  return pathname.split("/")[2];
};

const getParameters = (parameter) => {
  const parameters = new URLSearchParams(location.search);
  return parameters.get(parameter);
};

const getTypesParameters = () => {
  const parameters = new URLSearchParams(location.search);
  return parameters.getAll("filter.p.product_type");
};

const getTypesCondition = () => {
  const collection = getCollection();
  let conditions = [];

  for (let i = 0; i < collection.rules.length; i++) {
    conditions[i] = collection.rules[i].condition;
  }
  return conditions;
};

const getVendorCondition = () => {
  const collection = getCollection();
  collection.rules.forEach((rule) => {
    vendor = rule.condition;
  });
  return vendor;
};

const setAgeInForm = () => {
  const variables = getVariables();
  const productAgeOptions = document.querySelectorAll("#productAge option");
  productAgeOptions.forEach((productAgeOption) => {
    if (productAgeOption.value == variables.age) {
      productAgeOption.selected = true;
    }
  });
};

const setVendorInForm = () => {
  const variables = getVariables();
  const productVendorOptions = document.querySelectorAll(
    "#productVendor option"
  );
  productVendorOptions.forEach((productVendorOption) => {
    if (productVendorOption.value == variables.vendor) {
      productVendorOption.selected = true;
    }
  });
};

const setPriceInForm = () => {
  const variables = getVariables();
  const productPriceOptions = document.querySelectorAll("#productPrice option");
  productPriceOptions.forEach((productPriceOption) => {
    if (productPriceOption.value == variables.priceMin) {
      productPriceOption.selected = true;
    }
  });
};

const setAvailabilityInForm = () => {
  const variables = getVariables();
  const availability = variables.availability;

  const availability1 = document.getElementById("availability1");
  const availability0 = document.getElementById("availability0");

  if (availability === null) {
    availability1.checked = true;
    availability0.checked = true;
  } else if (availability === "1") {
    availability1.checked = true;
    availability0.checked = false;
  } else if (availability === "0") {
    availability1.checked = false;
    availability0.checked = true;
  } else {
    availability1.checked = true;
    availability0.checked = true;
  }
};

const setParentAndChildCategoryInForm = () => {
  // 初期値のproduct_typeと一致する子カテゴリのオプションを選択された状態にする
  const variables = getVariables();
  const productTypeChildOptions = document.querySelectorAll(
    "#productTypeChild option"
  );
  productTypeChildOptions.forEach((productTypeChildOption) => {
    let productTypeChildOptionChild = productTypeChildOption.dataset.child;
    variables.types.forEach((type) => {
      if (productTypeChildOptionChild == type) {
        productTypeChildOption.selected = true;
        const productTypeParentOptions = document.querySelectorAll(
          "#productTypeParent option"
        );
        productTypeParentOptions.forEach((productTypeParentOption) => {
          if (
            productTypeChildOption.dataset.parent ==
            productTypeParentOption.value
          ) {
            productTypeParentOption.selected = true;
          }
        });
      }
    });
  });
};

const setParentCategoryInForm = () => {
  // 初期値のproduct_typeから該当の親カテゴリのオプションを選択された状態にする
  const variables = getVariables();
  const productTypeChildOptions = document.querySelectorAll(
    "#productTypeChild option"
  );
  productTypeChildOptions.forEach((productTypeChildOption) => {
    let productTypeChildOptionChild = productTypeChildOption.dataset.child;
    variables.types.forEach((type) => {
      if (productTypeChildOptionChild == type) {
        const productTypeParentOptions = document.querySelectorAll(
          "#productTypeParent option"
        );
        productTypeParentOptions.forEach((productTypeParentOption) => {
          if (
            productTypeChildOption.dataset.parent ==
            productTypeParentOption.value
          ) {
            productTypeParentOption.selected = true;
          }
        });
      }
    });
  });
};

// リンク先のURLをセットする関数
const setFormUrl = () => {
  // フォームで選択された選択肢から、最大価格の隠しフィールドへ値を設定する
  setPriceMaxInForm();

  const productTypeParentValue =
    document.getElementById("productTypeParent").value;
  const productTypeChild = document.getElementById("productTypeChild");

  let formUrl = "/collections/" + getCollectionHandle();
  const collection = getCollection();
  const collectionRule = getCollectionRule(collection);

  if (collectionRule == "tag") {
    if (productTypeChild.value != "") {
      // 子カテゴリをproduct_typeに設定
      const productTypeChildOptions = document.querySelectorAll(
        "#productTypeChild option"
      );
      productTypeChildOptions.forEach((productTypeChildOption) => {
        if (productTypeChildOption.value == productTypeChild.value) {
          productTypeChild.name = "filter.p.product_type";
          productTypeChildOption.value = productTypeChildOption.dataset.child;
        }
      });
    } else if (productTypeParentValue != "") {
      // 親カテゴリのみが選択されている場合jsonから該当の子カテゴリ取得して隠しフィールドを設置する
      const collectionParentHandleAndChildProductTypeSet =
        getCollectionParentHandleAndChildProductType();
      collectionParentHandleAndChildProductTypeSet.forEach(
        (collectionParentHandleAndChildProductType) => {
          if (
            collectionParentHandleAndChildProductType.parentHandle ==
            productTypeParentValue
          ) {
            const productTypes =
              collectionParentHandleAndChildProductType.childProductType;
            // 子カテゴリをループして隠しフィールドを設置
            productTypes.forEach((type) => {
              createInputTag(type);
            });
          }
        }
      );
    }
  } else if (productTypeChild.value != "") {
    formUrl = "/collections/" + productTypeChild.value;
  } else if (productTypeParentValue != "") {
    formUrl = "/collections/" + productTypeParentValue;
  } else {
    formUrl = "/collections/all";
  }
  const productSearchForm = document.getElementById("productSearchForm");
  productSearchForm.setAttribute("action", formUrl);
};

// フォームで選択された選択肢から、最大価格の隠しフィールドへ値をを設定する関数
const setPriceMaxInForm = () => {
  const productPrice = document.getElementById("productPrice");
  const productPriceMax = document.getElementById("productPriceMax");
  if (productPrice.value == "0") {
    productPriceMax.value = 1000;
  } else if (productPrice.value == "1001") {
    productPriceMax.value = 3000;
  } else if (productPrice.value == "3001") {
    productPriceMax.value = 5000;
  } else if (productPrice.value == "5001") {
    productPriceMax.value = 10000;
  } else if (productPrice.value == "10001") {
    productPriceMax.value = 20000;
  } else if (productPrice.value == "20001") {
    productPriceMax.value = "20000";
  } else {
    productPriceMax.value = "";
  }
};

// 隠しフィールドを生成して設置する関数
const createInputTag = (type) => {
  const productSearchForm = document.getElementById("productSearchForm");
  let input = document.createElement("input");
  input.type = "hidden";
  input.name = "filter.p.product_type";
  input.value = type;
  input.classList.add("product_type_hidden");
  productSearchForm.appendChild(input);
};

const changeCheckbox = () => {
  setCheckBox();
  document
    .querySelectorAll(".products_search_checkbox input[type=checkbox]")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        setCheckBox();
      });
    });
};
const setCheckBox = () => {
  if (availability1.checked === true && availability0.checked === false) {
    availability.value = 1;
  } else if (
    availability1.checked === false &&
    availability0.checked === true
  ) {
    availability.value = 0;
  } else {
    availability.value = "0,1";
  }
};
